<div>
    <div *ngIf="telamaticVehicles">
        <app-dynamic-table title="{{'@telematicDevices'}}" [dataSource]="telematicVehicleTableData" [gridDisplayColumns]="telematicDeviceDisplayColumns" [hideFilters]="true" [hidePaginator]="true" [functions]="telematicDeviceFunctions" (functionCallback)="processTelematicDeviceFunction($event)" includeSelect="true" [length]="telamaticVehicles.length"></app-dynamic-table>
    </div>
</div>